import { createContext, useState, useEffect, useCallback, useContext } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext({
  authState: { isAuthenticated: false, token: null, user: null },
  login: () => {},
  logout: () => {},
  loginError: null,
  setLoginError: () => {},
});

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    token: null,
    user: null,
  });
  const [loginError, setLoginError] = useState(null);
  const navigate = useNavigate();
  const defined = (v) => v !== undefined && v !== null && v !== "";


  const logout = useCallback(() => {
    setAuthState({
      isAuthenticated: false,
      token: null,
      user: null,
    });
    sessionStorage.removeItem('authToken');
    navigate('/login');
  }, [navigate]);

// alert(JSON.stringify(sessionStorage))

  useEffect(() => {

    const storedToken = sessionStorage.getItem('authToken');
    const storedEmail = sessionStorage.getItem('email');
    const storedRoles = JSON.parse(sessionStorage.getItem('roles') || '[]');
    const storedUserState = sessionStorage.getItem('userState');
    console.log("User State sent", storedUserState);
    console.log("Roles sent", storedRoles);
    if (storedToken) {
      console.log("Stored token found:", storedToken, storedEmail, storedRoles, storedUserState);
      const isHelp = Array.isArray(storedRoles) && storedRoles.includes("fcwdHelpDesk");
      const source = isHelp ? "HelpDesk" : "StatesUI";
      try {
        setAuthState({
          isAuthenticated: true,
          token: storedToken,
          user: {
            email: storedEmail,
            roles: Array.isArray(storedRoles) ? storedRoles : [], // Ensure roles is an array
            //source: storedUserState === 'HQ' ? 'HelpDesk' : 'StatesUI',
            //source: storedUserState === 'HQ' ? 'HelpDesk' : 'HelpDesk',
            source: source,
            userState: storedUserState,
          }
        });
      } catch (error) {
        console.error('Failed to decode stored token:', error);
        logout();
      }
    } else if (!authState.isAuthenticated) {
      navigate('/login');
    }
  }, [navigate, authState.isAuthenticated, logout]);

  const login = (token, email, roles, userState) => {
    const isHelp = Array.isArray(roles) && roles.includes("fcwdHelpDesk");
    const source = isHelp ? "HelpDesk" : "StatesUI";
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        sessionStorage.setItem('authToken', token);
        sessionStorage.setItem('email', email); 
        sessionStorage.setItem('roles', JSON.stringify(roles || [])); // Store roles as a JSON string
        sessionStorage.setItem('source', source);
        sessionStorage.setItem('userState', userState);
        setAuthState({
          isAuthenticated: true,
          token,
          user: {
            email: email,
            roles: roles || [], // Ensure roles is an array
            source: source,
            userState: userState,
          },
        });
        setLoginError(null);
      } catch (error) {
        console.error('Failed to decode token:', error);
        setLoginError('Invalid token. Please try again.');
        logout();
      }
    } else {
      setLoginError('No token provided. Please try again.');
    }
  };

  return (
    <AuthContext.Provider value={{ authState, login, logout, loginError, setLoginError }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const { authState, login, logout, loginError, setLoginError } = useContext(AuthContext);
  return {
    isAuthenticated: authState.isAuthenticated,
    email: authState.user?.email,
    roles: authState.user?.roles || null, // Assuming roles is an array and we take the first role
    source: authState.user?.source,
    userState: authState.user?.userState,
    token: authState.token,
    user: authState.user,
    login,
    logout,
    loginError,
    setLoginError,
  };
};
